const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

export const HOMEPAGE_URL = conf[env].VUE_APP_LOCATION
export const DOMAIN = conf[env].VUE_APP_PATH_API
const API_ENDPOINT = (PATH, VERSION) => {
  if (VERSION) {
    return `${DOMAIN}${API_VERSION(VERSION)}/${PATH}`
  }

  return `${DOMAIN}${PATH}`
}
const API_VERSION = (version = 'v1') => `api/${version}`
const familyQuotationV1BaseUrl = API_ENDPOINT('family-quotation', 'v1')

const API = {
  ADDRESS: {
    COUNTRY: API_ENDPOINT('country'),
    PROVINCE: API_ENDPOINT('province'),
    DISTRICT: provinceId => `${API_ENDPOINT('amphoe')}?province_id=${provinceId}`,
    SUB_DISTRICT: (provinceId, districtId) =>
      `${API_ENDPOINT('tambon')}?province_id=${provinceId}&amphoe_id=${districtId}`,
  },
  QUOTATION: {
    GET_QUOTATION_INFORMATION: quotationId => `${API_ENDPOINT('quotation', 'v1')}/${quotationId}`,
    UPDATE_QUOTATION_INFORMATION: quotationId =>
      `${API_ENDPOINT('quotation', 'v1')}/${quotationId}`,
    UPDATE_QUOTATION_COMPLETE_STATUS: quotationId =>
      `${API_ENDPOINT('quotation/quotation-complete-status', 'v1')}/${quotationId}`,
    CUSTOMER_INQUIRY: (cardType, citizenId) =>
      `${API_ENDPOINT('quotation/customer', 'v1')}?cardType=${cardType}&citizenId=${citizenId}`,
    UPDATE_QUOTATION: quotationId => `${API_ENDPOINT('quotation')}/${quotationId}`,
    CHECK_RISK_TMB: API_ENDPOINT('quotation/check-risk-tmb', 'v1'),
    CHECK_RISK_TVI: API_ENDPOINT('quotation/check-risk-tvi', 'v1'),
    CHECK_RISK_PAYER: quotationId =>
      `${API_ENDPOINT('quotation/check-risk-payer', 'v1')}/${quotationId}`,
    CREATE_QUOTATION_WITH_CHECK_RISK: API_ENDPOINT('check-risk-new-quotation'),
    UPDATE_IS_OFFSIDE_SALE: quotationId => `${API_ENDPOINT(`quotation/offside-sale/${quotationId}`, 'v1')}`,
    GET_QUOTATION_COLUMNS: (quotationId, columns) => `${API_ENDPOINT(`quotation/columns/${quotationId}?columns=${columns}`, 'v1')}`
  },
  FAMILY: {
    CREATE_FAMILY_QUOTATION: API_ENDPOINT('family-quotation'),
    GET_FAMILY_INFORMATION: familyId => `${API_ENDPOINT('family')}/${familyId}`,
    UPDATE_FAMILY_RELATIONSHIP: quotationId => `${API_ENDPOINT('family-status')}/${quotationId}`,
    GET_FAMILY_PAYER: familyId => `${API_ENDPOINT('family-quotation', 'v1')}/${familyId}/payer`,
    GET_IS_OFFSIDE_SALE_BY_ID: familyId => `${familyQuotationV1BaseUrl}/${familyId}/is-offside-sale`,
    PUT_IS_OFFSIDE_SALE_BY_ID: familyId => `${familyQuotationV1BaseUrl}/${familyId}/is-offside-sale`,
  },
  GENERAL: {
    OCCUPATION: API_ENDPOINT('occupation'),
    NAME_PREFIX: API_ENDPOINT('title'),
    FAMILY_RELATIONSHIP: API_ENDPOINT('family-relation'),
    BENEFICIARY_RELATIONSHIP: API_ENDPOINT('beneficiary-relation'),
    HOSPITALS: subdistrictId => `${API_ENDPOINT('hospitals')}/${subdistrictId}`,
  },
  REFERRAL: {
    GET_REFERRER: staffId => `${API_ENDPOINT('referrer')}/${staffId}`,
    ADD_REFERRER: API_ENDPOINT('referrer'),
    UPDATE_REFERRER_INFORMTAION: staffId => `${API_ENDPOINT('referrer')}/${staffId}`,
    UPDATE_REFERRER_STATUS: staffId => `${API_ENDPOINT('referrer-status')}/${staffId}`,
  },
  APPLICATION: {
    CREATE_APPLICATION: quotationId => `${API_ENDPOINT('application')}/${quotationId}`,
    GET_APPLICATION_INFORMATION: applicationId =>
      `${API_ENDPOINT('application', 'v1')}/${applicationId}`,
    GET_CONSENT_INFORMATION: applicationId => `${API_ENDPOINT('/consent-images')}/${applicationId}`,
    UPDATE_APPLICATION_INFORMATION: applicationId =>
      `${API_ENDPOINT('application')}/${applicationId}`,
    UPDATE_APPLICATION_COMPLETE_STATUS: applicationId =>
      `${API_ENDPOINT('application/application-complete-status', 'v1')}/${applicationId}`,
    UPDATE_PAYER_INFORMATION: quotationId =>
      `${API_ENDPOINT('family-quotation-payer')}/${quotationId}`,
    UPDATE_MAIN_PAYER: familyId => `${API_ENDPOINT('family-main-payer')}/${familyId}`,
    UPDATE_CONSENT_INSURED: applicationId =>
      `${API_ENDPOINT('application', 'v1')}/${applicationId}/insured-person-consent`,
    UPDATE_CONSENT_PAYER: applicationId =>
      `${API_ENDPOINT('application', 'v1')}/${applicationId}/payer-person-consent`,
  },
  PACKAGE_PLAN: {
    GET_INSURANCE_PLAN: API_ENDPOINT('plan'),
    GET_DEDUCT_PLAN: API_ENDPOINT('plan-deduct'),
    GENERATE_QUICK_QUOTATION: API_ENDPOINT('quotation/quick-quotation', 'v1'),
  },
  PAYMENT: {
    GET_PAYMENT_INFORMATION: applicationId => `${API_ENDPOINT('payment-info')}/${applicationId}`,
    TMB_DIRECT_DEBIT: {
      GET_TMB_ACCOUNT_INFORMATION: API_ENDPOINT('check-tmb-direct-debit'),
      SEND_TMB_OTP: API_ENDPOINT('send-tmb-otp'),
      VERIFY_TMB_OTP: applicationId => `${API_ENDPOINT('verify-tmb-otp')}/${applicationId}`,
    },
    BILL_PAYMENT: applicationId =>
      `${API_ENDPOINT('application/bill-payment-detail', 'v1')}/${applicationId}`,
    QRCODE: (type, id, socketId) => `${API_ENDPOINT('qr')}/${type}/${id}/${socketId}`,
    VERIFY_SLIP: API_ENDPOINT('qr-slip-verify'),
    CREDIT_CARD: API_ENDPOINT('payment-credit-card/checkout', 'v1'),
    CREDIT_CARD_VERIFY_TOKEN: omiseToken =>
      `${API_ENDPOINT('payment-credit-card', 'v1')}/${omiseToken}/complete`,
    POLICY_PROCESS_COMPLETE: applicationId => `${API_ENDPOINT('thankyou')}/${applicationId}`,
  },
  WEB_SOCKET: {
    QRCODE: 'http://localhost:3000',
  },
  DOCUMENTS: {
    TVI_LOGO: 'https://d285udyjz4p93l.cloudfront.net/tmbxtvi/tvi_logo.jpg',
    INDIVIDUAL_MANUAL:
      'https://d1b5jt50ydmx71.cloudfront.net/Manual_TMB_Health_Care_Plus.pdf',
    FAMILY_MANUAL:
      'https://d1b5jt50ydmx71.cloudfront.net/Manual_TMB_Health_Care_Plus_Family.pdf',
    INSURANCE_BROCHURE:
      'https://d1b5jt50ydmx71.cloudfront.net/TMB_Health_Care_Plus_Brochure.pdf',
    GENERATE_POLICY: applicationId => `${API_ENDPOINT('generate-policy', 'v1')}/${applicationId}`,
    SEND_EMAIL_POLICY: applicationId =>
      `${API_ENDPOINT('resend-email-policy', 'v1')}/${applicationId}`,
  },
  BACK_OFFICE: {
    GET_REFERRER_LIST: API_ENDPOINT('list-referrer'),
  },
  AUTHORIZATION: {
    PAGE_AUTH: pageName => `${API_ENDPOINT('page-auth')}/${pageName}`,
    LOGOUT: API_ENDPOINT('logout'),
    SCOPE: API_ENDPOINT('scope'),
  },
}

export default API
